var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadMicrophone = function SvgFadMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.618 178.111 9.64 9.846-17.04 16.203s-.704 1.517.711 3.282c1.415 1.766 2.844.578 2.844.578l17.266-16.088 9.344 9.14 94.71-75.646s12.474.1 23.552-10.425c17.795-16.91 14.266-40.487 1.25-54.93-13.017-14.442-37.846-16.699-53.643-3.2-12.96 11.073-12.99 26.863-12.99 26.863l-75.644 94.377z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.347 176.967 5.687 5.484 75.162-59.15s-8.01-4.416-12.813-9.469c-4.804-5.053-7.58-11.981-7.58-11.981l-60.456 75.116zm75.827-105.668s-13.299 18.34 2.398 33.329c15.698 14.99 33.564 2.4 33.564 2.4s-16.071-3.727-24.79-12.39c-8.72-8.662-11.172-23.34-11.172-23.34z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.567 66.786s3.702 14.109 12.601 23.073c8.899 8.965 22.874 12.662 22.874 12.662s12.885-19.52-3.271-34.318c-16.157-14.798-32.204-1.417-32.204-1.417z",
    fill: "#FFF"
  }))));
};
export { SvgFadMicrophone as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-microphone.8ae948ae.svg";